import {
  APP_BACKGROUND_COLOR,
  BUTTON_TEXT_COLOR,
  FONT_FAMILY,
} from "../../theme";

export const styles = {
  selectOptionHeading: {
    fontFamily: FONT_FAMILY,
    fontSize: "28px",
    fontWeight: "bold",
    textAlign: "center",
  } as const,
  logoutMainContainer: {
    width: "100%",
    overflowY: "scroll",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  } as const,
  logoutContainer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 20px 0px 0px",
  } as const,
  logoutButton: {
    backgroundColor: APP_BACKGROUND_COLOR,
    border: `1px solid gray`,
    textTransform: "none",
    color: BUTTON_TEXT_COLOR,
  } as const
};
